import { Link } from "react-router-dom";
import { LOGO_WEBSITE_URL, SERVICES, CONTACT } from "@/lib/constants";
import { MessageCircle, Send, MapPin } from "lucide-react";

/* @section: footer */
export default function Footer() {
  return (
    <footer className="bg-[#1C6034] text-gray-400 border-t border-[#FFE000]/20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="md:col-span-1">
            <Link to="/" className="flex items-center mb-3">
              <img src={LOGO_WEBSITE_URL} alt="YoYo Massage Wellness" className="h-14 w-auto" />
            </Link>
            <p className="text-gray-500 text-sm">專業養生按摩·身心靈調理</p>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-white font-semibold mb-3 text-sm uppercase tracking-wider">服務項目</h3>
            <ul className="space-y-2">
              {SERVICES.map((s) => (
                <li key={s.id}>
                  <Link to={s.slug} className="text-gray-400 hover:text-[#FFE000] text-sm transition-colors">
                    {s.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Navigation */}
          <div>
            <h3 className="text-white font-semibold mb-3 text-sm uppercase tracking-wider">導覽</h3>
            <ul className="space-y-2">
              {[
                { href: "/", label: "主頁" },
                { href: "/blog", label: "養生博客" },
                { href: "/reviews", label: "客戶評價" },
              ].map((l) => (
                <li key={l.href}>
                  <Link to={l.href} className="text-gray-400 hover:text-[#FFE000] text-sm transition-colors">
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-white font-semibold mb-3 text-sm uppercase tracking-wider">立即預約</h3>
            <ul className="space-y-3">
              <li>
                <a href={CONTACT.whatsapp} target="_blank" rel="noopener noreferrer"
                   className="flex items-center gap-2 text-sm text-gray-400 hover:text-[#25D366] transition-colors">
                  <MessageCircle size={16} className="text-[#25D366]" />
                  WhatsApp 預約
                </a>
              </li>
              <li>
                <a href={CONTACT.telegram} target="_blank" rel="noopener noreferrer"
                   className="flex items-center gap-2 text-sm text-gray-400 hover:text-[#2AABEE] transition-colors">
                  <Send size={16} className="text-[#2AABEE]" />
                  Telegram 預約
                </a>
              </li>
              <li>
                <a href={CONTACT.tgChannel} target="_blank" rel="noopener noreferrer"
                   className="flex items-center gap-2 text-sm text-gray-400 hover:text-[#2AABEE] transition-colors">
                  <Send size={16} className="text-[#2AABEE]" />
                  TG Channel
                </a>
              </li>
              <li className="flex items-center gap-2 text-sm">
                <MapPin size={16} className="text-[#FFE000] flex-shrink-0" />
                <span>{CONTACT.location}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-10 pt-6 flex flex-col sm:flex-row justify-between items-center gap-2">
          <p className="text-gray-600 text-xs">© 2026 YoYo Massage Wellness. All rights reserved.</p>
          <p className="text-gray-600 text-xs">本中心服務僅供保健調理，不提供醫療診斷或處方。</p>
        </div>
      </div>
    </footer>
  );
}
